import { render, staticRenderFns } from "./bulk.vue?vue&type=template&id=0bd8d43c&"
import script from "./bulk.vue?vue&type=script&lang=js&"
export * from "./bulk.vue?vue&type=script&lang=js&"
import style0 from "./bulk.vue?vue&type=style&index=0&id=0bd8d43c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports